let config = null;
let configPromise = null;

export async function loadConfig() {
  if (config) {
    return config;
  }

  if (!configPromise) {
    configPromise = fetch('/config.json', {
      cache: 'no-store',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to load config');
        }
        return response.json();
      })
      .then((data) => {
        config = data;
        return data;
      })
      .finally(() => {
        configPromise = null;
      });
  }

  return configPromise;
}

export function getLoadedConfig() {
  return config;
}
